import { Modal, type ModalProps } from 'antd';
import type { ReactNode } from 'react';
import {
  getResponsiveModalWidth,
  type ModalWidthPreset,
} from '../../utils/modal-width';
import { FlatDetailContext } from '../detail-surface';
import styles from './style.module.less';

type BusinessModalProps = ModalProps & {
  /** Detail shells own their heading and scrollable work area. */
  detail?: boolean;
  'aria-label'?: string;
  widthPreset?: ModalWidthPreset;
  extra?: ReactNode;
};

/** Shared viewport bounds for CRM business dialogs, including portal content. */
export function BusinessModal({
  detail = false,
  widthPreset = detail ? 'detail' : 'large',
  extra,
  'aria-label': accessibleLabel,
  title,
  className,
  children,
  ...props
}: BusinessModalProps) {
  return (
    <Modal
      closable={{ 'aria-label': '关闭' }}
      keyboard
      centered
      footer={null}
      destroyOnHidden
      {...props}
      width={props.width ?? getResponsiveModalWidth(widthPreset)}
      className={[styles.modal, detail ? styles.detail : '', className]
        .filter(Boolean)
        .join(' ')}
      title={
        detail && accessibleLabel ? (
          accessibleLabel
        ) : extra ? (
          <div className={styles.heading}>
            <span>{title}</span>
            <div className={styles.actions}>{extra}</div>
          </div>
        ) : (
          title
        )
      }
    >
      <FlatDetailContext.Provider value={detail}>
        {children}
      </FlatDetailContext.Provider>
    </Modal>
  );
}
